export default import.meta.ROLLDOWN_FILE_URL_SoaXe9YxlNqn8Z1ElY$2Jg